{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              141.3407656096963,
              -9.4639093163712
            ],
            [
              147.3369574274683,
              45.04646713435508
            ],
            [
              113.42130767414551,
              41.27686333706416
            ],
            [
              97.39041307860668,
              18.182180021210485
            ],
            [
              90.12731621198441,
              12.248830273496864
            ],
            [
              93.81240575762206,
              2.584572790926643
            ],
            [
              101.89403037176828,
              -8.565418715654474
            ],
            [
              117.39791077749709,
              -11.610300875953897
            ],
            [
              132.76990521383368,
              -9.516113273415456
            ],
            [
              141.3407656096963,
              -9.4639093163712
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}